module.exports = __webpack_public_path__ + "static/media/BMODE_20_10.caf54d36.jpg";